import React from 'react';
import LegalPage from '../components/LegalPage';

const PrivacyPolicy = () => {
  return (
    <LegalPage title="Privacy Policy">
      <div className="col-lg-12 mx-auto">
        <p>Cyberidge Construction Pty Ltd is committed to safeguarding the privacy of our clients, contractors, and stakeholders. We collect and manage personal information in compliance with the Privacy Act 1988 (Cth) to support our construction operations and related services.</p>
        
        <h4 className="mt-4">1. What Information Do We Collect?</h4>
        <p>We may collect personal information when:</p>
        <ul>
          <li>You engage with us for project inquiries, quotations, or collaborations;</li>
          <li>You submit online forms or contact us by phone or email;</li>
          <li>You enter our construction sites and complete visitor registration forms.</li>
        </ul>
        <p>This may include your name, contact details, company name, and other relevant identifiers.</p>
        
        <h4 className="mt-4">2. Why Do We Collect Your Information?</h4>
        <p>We collect personal information for purposes including:</p>
        <ul>
          <li>Communication and coordination related to construction projects;</li>
          <li>Compliance with site safety, visitor, and regulatory requirements;</li>
          <li>Technical support, reporting, and project follow-ups.</li>
        </ul>
        
        <h4 className="mt-4">3. How Do We Protect Your Information?</h4>
        <p>We apply strict security measures, including access controls, encrypted storage, physical safeguards, and staff training, to protect personal data from unauthorised use or disclosure.</p>
        
        <h4 className="mt-4">4. Site Visitor Data</h4>
        <p>If you visit one of our construction sites, your information is used solely for health, safety, and compliance purposes and will not be used for unrelated activities.</p>
        
        <h4 className="mt-4">5. Your Rights</h4>
        <p>You may request access to or correction of your personal data held by us. Please contact us to make a formal request.</p>
        
        <h4 className="mt-4">6. Disclaimer</h4>
        <p>Cyberidge Construction makes every effort to ensure accuracy, but does not guarantee completeness or assume liability for the use of information provided on this site or other materials.</p>
        
        <h4 className="mt-4">7. Contact Us</h4>
        <p>
          Cyberidge Construction Pty Ltd<br />
          Address: 3/22-28 Melbourne St, North Adelaide, SA 5006<br />
          Email: info@cyberidge.com.au<br />
          Phone: (08) 8257 9123
        </p>
        
        <p className="mt-5 text-muted">Last updated: 1 May 2025</p>
      </div>
    </LegalPage>
  );
};

export default PrivacyPolicy; 